import { Outlet } from 'react-router-dom';

import { Sidebar } from '@/components/layout/Sidebar';
import { Topbar } from '@/components/layout/Topbar';

/**
 * Layout for full-height pages (e.g. AI chat) that manage their own internal
 * scrolling. Unlike AppLayout, there is no padding wrapper — the Outlet fills
 * the entire area between the topbar and the bottom of the viewport.
 */
export function ChatLayout(): JSX.Element {
  return (
    <div className="flex h-screen overflow-hidden bg-ink-50 dark:bg-ink-950">
      <Sidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar />
        <main className="flex-1 overflow-hidden bg-dashboard">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
